var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5",on:{"click":function($event){return _vm.copyPath()}}},[_c('m_-button',{staticClass:"btn-warning"},[_c('b-icon',{attrs:{"icon":"files"}})],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }